// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/CreateTreatmentPlan/EditTreatmentAndPaymentPlans/New/Steps/PaymentPlans/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_CreateTreatmentPlan_EditTreatmentAndPaymentPlans_New_Steps_PaymentPlans($ids: [uuid!]!) {
  # TODO: this should fetch the treatment plans once those are saved
  # should just pass the treatment_id as a param in this case
  vaxiom_tx_plan_templates(
    where: { deleted: { _eq: false }, _id: { _in: $ids } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    _id
    name
    fee
    length_in_weeks
    insurance_code_id
  }
}

`